const weekConfig = {
  'Monday': 0,
  'Tuesday': 0,
  'Wednesday': 0,
  'Thursday': 0,
  'Friday': 0,
  'Saturday': 1,
  'Sunday': 1
}
// 获取日期是否周末
export function weekendMarkCaculate (data = [], dateToWeek = {}) {
  const result = {
    itemStyle: {
      color: 'rgba(140,140,140,0.05)'
    },
    data: []
  }

  let weekend = []
  data.forEach(item => {
    const isWeekend = weekConfig[dateToWeek[item]]
    switch (weekend.length) {
      case 0:
        if (isWeekend) {
          weekend.push({
            xAxis: item.substring(5)
          })
        }
        break
      case 1:
        if (isWeekend) {
          weekend.push({
            xAxis: item.substring(5)
          })
        } else {
          weekend.push(Object.assign({}, weekend[0]))
        }
        break
      case 2:
        result.data.push(weekend)
        weekend = []
        break
      default:
        break
    }
  })
  return result
}

// 获取最大值
export function getMaxValue (chartData = {}, exclude = []) {
  let max = 0

  for (let key in chartData) {
    const tmpData = chartData[key] || []
    if (exclude.indexOf(key) === -1) {
      max += Math.max.apply(null, tmpData.map(item => item.value))
    }
  }
  return Math.abs(max)
}

// 获取最大长度的数字
export function getMaxLengthValue (chartData = {}, exclude = []) {
  let max = 0
  let values = []
  for (let key in chartData) {
    const tmpData = chartData[key] || []
    if (exclude.indexOf(key) === -1) {
      values = values.concat(tmpData.map(item => item.value))
    }
  }

  if (values.length === 0) {
    return 0
  }
  max = values[0]
  values.forEach(item => {
    if ((max + '').length < (item + '').length) {
      max = item
    }
  })
  return max
}
